 
  <script>
  import GiftApi from "@/services/gift-api";
  import {GiftType} from "./giftTypeEnum";

  export default {
    props: {
      showGiftModal: {
        type: Boolean,
        required: true
      },
      gift: {
        type: Object,
        default: () => ({})
      },
      showForm: {
        type: Boolean,
      },
      modalCode: {
        type: String,
      },
      giftWinner: {
        type: Object,
        default: () => ({
          name: '',
          phone: '',
          email: ''
        })
      }
    },

    data() {
        return{
          giftType:GiftType
        }
    },

    methods: {
        closeGiftWinner() {
            this.$emit('close-gift-winner', this.giftWinner);
        },

        saveGiftWinner(){
          const giftCode = this.modalCode;
            this.giftWinner.code= giftCode ,  
            GiftApi.saveGiftWinner(this.giftWinner).then((result)=>{
                if(result){
                    this.closeGiftWinner()
                }
            })

        },
    }
  }
  </script>
  
  
  <style>

  .gift-modal-background {
      background-color: #49b69f /*#FFF8E9*/ !important; 
      border: 1px solid #49b69f/*#FFF8E9*/ !important;
  }

  

  </style>

  <template>
    <b-modal v-model="showGiftModal" 
             hide-footer 
             hide-header
             centered 
             title-class="text-primary"
             title-tag="h5"
             header-close-variant="danger"
             no-close-on-esc
             no-close-on-backdrop
             content-class="gift-modal-background"
             :size="gift && gift.image ? 'lg' : 'md' " >
    <div >
      <div class="row p-4">
        <div class="col-12">
          <img class="" src="@/assets/images/congrats-banner.jpg" width="100%" >
        </div>
      </div>

      <!-- <div class="row ">
        <div class="col-12">
          <img :src="'/api/image/get/' + gift.image" width="100%" height="auto" />
        </div>
      </div> -->

      <!--div class="float-right" style="cursor: pointer;" @click="closeGiftWinner()">X</div-->

      <div class="row mt-4">

        <div v-if="gift && gift.image" class="col-12 col-lg-7 col-md-12 text-center pr-md-2 pb-md-2 my-auto">
          <img class="mt-2 mb-2" :src="'/api/image/get/' + gift.image" width="100%" height="auto" />
        </div>
        
  

        <div :class="gift && gift.image ? 'col-12 col-lg-5 col-md-12 pr-2' : 'col-12'">

          <!--div class="text-center">
            <img class="mb-2" src="@/assets/images/gift-box.jpg" width="200px" height="200px">
          </div-->
  
          <strong class="text-left font-size-16 text-dark font-weight-bold">
            Félicitations !
          </strong>
          <div class="mt-2 font-size-16 text-justify text-dark font-weight-bold">
            HA vous offre
            <span class="text-dark" v-if="gift && gift.giftType == giftType.PHYSICAL ">
              <strong>{{ gift && gift.name ? gift.name : '' }}</strong>
            </span>
            <strong class="text-dark" v-else>
              une carte cadeau de {{ gift && gift.percentAsString ? gift.percentAsString : gift && gift.amountAsString ? gift.amountAsString : '' }}
            </strong>
            en reconnaissance de votre confiance et de votre fidélité.
          
            <div v-if="gift && gift.giftType == giftType.PROMOTION_CARD" class="font-weight-bold mt-4">
              Le code de la carte promo vous sera envoyé par email et par SMS.
            </div> 
          </div>
  
          <div v-if="showForm" class="text-left text-justify">
            
            <div class="mt-4 text-dark font-weight-bold font-size-16 text-justify" >
              Pour finaliser la réception de votre cadeau, merci de remplir le formulaire ci-dessous dans un délai de 5 minutes.
            </div> 
            
            <div class="mt-4 text-dark font-weight-bold ">
              <b-form-group class="text-dark" label="Nom & Prenom" label-for="">
                <b-form-input v-model="giftWinner.name" class="form-control font-size-14 mr-4 text-dark" placeholder="Nom & Prenom"/>
              </b-form-group>
            </div>
  
            <div class="text-dark font-weight-bold">
              <b-form-group class="text-dark" label="Téléphone" label-for="">
                <b-form-input v-model="giftWinner.phone" class="form-control font-size-14 mr-4 text-dark" placeholder="Téléphone"/>
              </b-form-group>
            </div>
  
            <div class="text-dark font-weight-bold ">
              <b-form-group class="text-dark" label="E-mail" label-for="">
                <b-form-input v-model="giftWinner.email" class="form-control font-size-14 mr-4 text-dark" placeholder="E-mail"/>
              </b-form-group>
            </div>
  
            
          </div>

          <div class="row pt-3 ">
            <small class="text-muted" v-if="gift && gift.giftType == giftType.PHYSICAL ">* Nous vous contacterons pour convenir de la date de remise du cadeau</small>
            <small v-else class="text-muted">* Les codes promo ne peuvent être utilisés que sur les articles non soldés</small>    
          </div>

          <div class="row pt-3 ">
                <div :class="showForm ? 'col-2 col-xs-0' : 'col-7 col-xs-0' "></div>



                <div class="col-sm-5 col-xs-12 text-right p-2">
                  <b-button variant="transparent" class="w-100 font-weight-bold text-dark border border-white" @click="closeGiftWinner()">
                    <span class="font-size-14 font-weight-bold">
                      {{ showForm ? 'Non, merci' : 'Fermer' }}
                    </span>
                  </b-button>
                </div>

                <div v-if="showForm" class="col-sm-5 col-xs-12 text-right pr-0 pl-2 pt-2 pb-2">
                  <b-button variant="dark" class="w-100 font-weight-bold text-dark border border-white" @click="saveGiftWinner">
                    <span class="font-size-14 font-weight-bold">
                      <img alt="" class="mr-2" width="15px" src="@/assets/icons/congrats.svg" />
                      Envoyer
                    </span>
                  </b-button>
                </div>

          </div>
              
          </div> 

        </div>
      </div>
    </b-modal>
  </template>